import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const Gynae = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is PCOS/PCOD and how is it treated?",
      answer:
        "PCOS is a hormonal disorder causing irregular periods and fertility issues. It is managed through lifestyle changes, medications, and hormonal therapy."
    },
    {
      question: "When should I visit a gynecologist?",
      answer:
        "You should visit for irregular periods, pregnancy planning, pelvic pain, or routine checkups."
    },
    {
      question: "Is gynecological consultation confidential?",
      answer:
        "Yes, all consultations are completely private and handled with utmost care and confidentiality."
    },
    {
      question: "Do you handle high-risk pregnancies?",
      answer:
        "Yes, we provide specialized care and monitoring for high-risk pregnancies."
    },
    {
      question: "Can gynecological issues affect fertility?",
      answer:
        "Yes, conditions like PCOS, fibroids, or hormonal imbalance can affect fertility but are treatable."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>Best Gynaecologist in Ambala | Pregnancy & PCOS Treatment | Amaanat IVF</title>

        <meta
          name="description"
          content="Consult experienced gynaecologists in Ambala at Amaanat IVF. Expert care for pregnancy, PCOS, infertility, and women's health."
        />

        <link rel="canonical" href="https://amaanativf.com/services/gynae" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            "name": "Amaanat IVF",
            "medicalSpecialty": "Gynecology",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ambala",
              "addressCountry": "India"
            }
          })}
        </script>

        {/* ✅ FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1>Gynaecologist & Pregnancy Care in Ambala</h1>

          <p>
            Complete care for women’s health, fertility & pregnancy
          </p>

          <div className="hero-stats">
            <span>24/7</span> Care Available
          </div>

        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          {/* SERVICES */}
          <section>
            <h2>Gynaecology Services in Ambala</h2>
            <ul>
              <li>Prenatal & Antenatal Care</li>
              <li>High-Risk Pregnancy Management</li>
              <li>Menstrual Disorder Treatment</li>
              <li>PCOS / PCOD Management</li>
              <li>Infertility Evaluation</li>
              <li>Hormonal Disorder Treatment</li>
              <li>Family Planning & Counseling</li>
            </ul>
          </section>

          {/* TREATMENTS */}
          <section className="service-grid">
            <h2>Specialized Women’s Treatments</h2>

            <div className="grid">
              <div className="card">Pregnancy Care</div>
              <div className="card">Ultrasound Monitoring</div>
              <div className="card">Laparoscopy</div>
              <div className="card">Menopause Care</div>
            </div>
          </section>

          {/* WHY */}
          <section className="why-section">
            <h2>Why Choose Our Gynaecology Clinic?</h2>
            <ul>
              <li>✔ Experienced Gynaecologists</li>
              <li>✔ Advanced Diagnostic Technology</li>
              <li>✔ Personalized Patient Care</li>
              <li>✔ Safe & Hygienic Environment</li>
            </ul>
          </section>

          {/* FAQ */}
          <section className="faq-section">
            <h2>Gynaecology FAQs</h2>

            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <div
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  {faq.question}
                  <span>{activeIndex === index ? '-' : '+'}</span>
                </div>

                {activeIndex === index && (
                  <div className="faq-answer">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </section>

          {/* ✅ Hidden SEO Block */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best Gynaecologist in Ambala</h2>
            <p>
              Amaanat IVF offers expert gynaecology services in Ambala including pregnancy care,
              PCOS treatment, infertility evaluation, and hormonal disorder management.
              Our experienced doctors provide personalized care for women at every stage of life.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Gynae;